import React from "react";
import { SubHeading } from "../Components";

const Dashboard = () => {
  return (
    <>
      <SubHeading subTitle="Dashboard" isAddBtn={false} />
    </>
  );
};

export default Dashboard;
